import React from "react";
import Skeleton from "react-loading-skeleton";

const RoleManagementTable = ({
  searchText,
  setSearchText,
  filteredRoles,
  isLoading,
  errorMessage,
  deletingRoleId,
  onEditRole,
  onDeleteRole,
}) => {
  const renderSkeletonRows = () =>
    Array.from({ length: 5 }).map((_, rowIndex) => (
      <tr key={`skeleton-row-${rowIndex}`}>
        {Array.from({ length: 5 }).map((__, colIndex) => (
          <td key={`skeleton-cell-${rowIndex}-${colIndex}`}>
            <Skeleton height={20} />
          </td>
        ))}
      </tr>
    ));

  const hasNoResults = !isLoading && !errorMessage && filteredRoles.length === 0;

  return (
    <div className="container-fluid pb-4">
      <div className="rr-manageCard">
        <div className="rr-manageHeader">
          <div>
            <h5 className="mb-1">Role Management</h5>
            <p className="mb-0 text-muted">Review and manage registered roles.</p>
          </div>
          <input
            type="text"
            className="form-control rr-manageSearch"
            placeholder="Search by role name"
            value={searchText}
            onChange={(event) => setSearchText(event.target.value)}
          />
        </div>

        <div className="table-responsive mt-3">
          <table className="table rr-table mb-0 table-hover table-collapsed">
            <thead>
              <tr>
                <th>Role Name</th>
                <th>Dealer Code</th>
                <th>Created By</th>
                <th>Created At</th>
                <th style={{ textAlign: "center" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                renderSkeletonRows()
              ) : errorMessage ? (
                <tr>
                  <td colSpan="5" className="text-center text-danger py-4">
                    Unable to load roles. {errorMessage}
                  </td>
                </tr>
              ) : hasNoResults ? (
                <tr>
                  <td colSpan="5" className="text-center text-muted py-4">
                    {searchText.trim()
                      ? "No matching roles found."
                      : "No roles available."}
                  </td>
                </tr>
              ) : (
                filteredRoles.map((role) => (
                  <tr key={role.id}>
                    <td>{role.name}</td>
                    <td>{role.dealerCode || "-"}</td>
                    <td>{role.createdBy}</td>
                    <td>{role.createdAt}</td>
                    <td className="rr-actionsCol" style={{ width: "12%" }}>
                      <div className="rr-actionsWrap">
                        <button
                          type="button"
                          className="btn rr-rowBtn"
                          disabled={Boolean(deletingRoleId)}
                          onClick={() => onEditRole(role)}
                        >
                          Edit
                        </button>
                        <button
                          type="button"
                          className="btn rr-rowBtn rr-rowBtnDanger"
                          disabled={Boolean(deletingRoleId)}
                          onClick={() => onDeleteRole(role)}
                        >
                          {String(deletingRoleId) === String(role.id) ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Deleting...
                            </>
                          ) : (
                            "Delete"
                          )}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default RoleManagementTable;
